import { Tooltip } from 'antd'

import { DEFAULT_NAME_WITH_TOOLTIP_LENGTH } from '@/constants'

import cn from './NameWithTooltip.module.scss'

type OrganisationNameProps = {
  location: 'organisationBar' | 'organisationBarAccent' | 'feedSearchTerm'
  name: string
}

function NameWithTooltip(props: OrganisationNameProps) {
  const { location, name } = props

  if (!name) return null

  return (
    <>
      {name.length > DEFAULT_NAME_WITH_TOOLTIP_LENGTH ? (
        <Tooltip title={name}>
          <span className={[cn.name, cn[location]].join(' ')}>
            {name.slice(0, DEFAULT_NAME_WITH_TOOLTIP_LENGTH) + '...'}
          </span>
        </Tooltip>
      ) : (
        <span className={[cn.name, cn[location]].join(' ')}>{name}</span>
      )}
    </>
  )
}

export default NameWithTooltip
